export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    goTo(route, params, query) {
      if (!isNaN(params)) {
        params = { id: params };
      }
      this.$router.push({ name: route, params, query });
    },
  },
};
